import { mapState } from 'vuex';

import { ALLOW_EDIT_TYPES, ORDER_STATUS_WITH_TYPE_TEXT } from '@/utils/constants';

export default {
  name: 'JoinedMembers',
  props: {
    allowEditType: {
      default: ALLOW_EDIT_TYPES.ALL,
      type: Number,
      validator: (val) => Object.values(ALLOW_EDIT_TYPES).includes(val),
    },
    members: {
      required: true,
      type: Array,
    },
    orderType: {
      default: ORDER_STATUS_WITH_TYPE_TEXT.DRAFT,
      type: String,
      validator: (val) => Object.values(ORDER_STATUS_WITH_TYPE_TEXT).includes(val),
    },
    originSelectedMembers: {
      default: () => ({}),
      type: Object,
    },
    selectedMembers: {
      default: () => ({}),
      type: Object,
    },
  },
  methods: {
    getDepartment(departmentId) {
      return this.departments.find((d) => String(d.id) === String(departmentId)) || {};
    },
    getDepartmentList(selectedData) {
      const result = {};
      const { includes = {}, excludes = {} } = selectedData;
      Object.keys(excludes).forEach((departmentId) => {
        const { member_count: count = 0, name = '' } = this.getDepartment(departmentId);
        if (!excludes[departmentId]?.length) {
          result[departmentId] = { count, name, id: departmentId };
        } else {
          result[departmentId] = {
            count: count - excludes[departmentId].length,
            name,
            id: departmentId,
          };
        }
      });
      Object.keys(includes).forEach((departmentId) => {
        const { name = '' } = this.getDepartment(departmentId);
        result[departmentId] = { count: includes[departmentId].length, name, id: departmentId };
      });
      return result;
    },
  },
  computed: {
    ...mapState('orders', ['departments']),
    hasOriginSelectedMembers() {
      const { includes = {}, excludes = {} } = this.originSelectedMembers;
      return Object.keys(includes).length || Object.keys(excludes).length;
    },
    hasSelectedMembers() {
      return Object.keys(this.departmentInfos).length;
    },
    originDepartmentInfos() {
      return this.getDepartmentList(this.originSelectedMembers);
    },
    departmentInfos() {
      const departments = this.getDepartmentList(this.selectedMembers);
      Object.keys(departments).forEach((id) => {
        departments[id].count -= (this.originDepartmentInfos[id]?.count || 0);
        if (!departments[id].count) {
          delete departments[id];
        }
      });
      return departments;
    },
    notAllowToEditMembers() {
      return this.allowEditType === ALLOW_EDIT_TYPES.NO_EDIT_MEMBERS;
    },
    onlyAllowToAddMembers() {
      return this.allowEditType === ALLOW_EDIT_TYPES.ONLY_ADD_MEMBERS;
    },
    originMembers() {
      return this.originSelectedIds
        .map((id) => this.members.find(({ id: mid }) => mid === id))
        .filter(Boolean);
    },
    originSelectedDescription() {
      const types = {
        [ORDER_STATUS_WITH_TYPE_TEXT.ENDED]: '*已截止訂購無法修改原有名單',
        [ORDER_STATUS_WITH_TYPE_TEXT.ONGOING]: '*開放中訂購無法修改原有名單',
      };
      return types[this.orderType] || '';
    },
  },
};
